<script>
import EventDetails from '@events/components/event-details.vue'
import { authComputed } from '@state/helpers'

// Show the details about an event
export default {
  name: 'EventCompany',
  components: { EventDetails },
  props: {
    event: {
      type: Object,
      required: true,
    },
    companyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      singleEvent: false,
    }
  },
  computed: { ...authComputed },
  methods: {
    close() {
      // go to events page with filters or company page
      const eventsWithFilters = window.localStorage.getItem(
        'events_with_filters'
      )
      if (eventsWithFilters) {
        window.location.href = window.localStorage.getItem(
          'events_with_filters'
        )
      } else {
        const { meta, params } = this.$route
        this.$router.push({
          name: meta.parentName,
          params: { companyId: params.companyId },
        })
      }
    },
  },
}
</script>

<template>
  <div>
    <EventDetails
      v-if="event"
      :one-event="event"
      :current-user-id="currentUserId"
      @close="close"
    ></EventDetails>
  </div>
</template>
